export { default } from './P14ProductCards';
